import React from 'react';
import BasicDetailsStep from '@/components/medication/BasicDetailsStep';
import ScheduleStep from '@/components/medication/ScheduleStep';
import CycleStep from '@/components/medication/CycleStep';
import AdditionalInfoStep from '@/components/medication/AdditionalInfoStep';
import { MedicationFormData } from '@/components/medication/types/medication';
import { useIsMobile } from '@/hooks/use-mobile';

interface ModalContentProps {
  currentStep: number;
  formData: MedicationFormData;
  updateFormData: (field: keyof MedicationFormData, value: any) => void;
  handleTimeSelection: (timeKey: string) => void;
  decrementDose: (timeKey: string) => void;
  removeDoseTime: (timeKey: string) => void;
  isMobile?: boolean; // Optional prop for explicit mobile layouts
}

/**
 * Dynamic content component that renders the appropriate step form
 * based on the current step number
 */
/**
 * ModalContent component renders the appropriate step form based on current step
 * following single responsibility principle from the windsurf rules
 * @param props - Component properties including current step and form data
 */
const ModalContent: React.FC<ModalContentProps> = ({
  currentStep,
  formData,
  updateFormData,
  handleTimeSelection,
  decrementDose,
  removeDoseTime,
  isMobile = useIsMobile() // Use injected prop or fallback to hook for better testability
}) => {

  return (
    <div className="px-6 py-3">
      {/* Use data-step attribute for accessibility and focus management */}
      <div data-step={currentStep} className="w-full">
        {currentStep === 1 && (
          <BasicDetailsStep 
            formData={formData} 
            updateFormData={updateFormData} 
          />
        )}
        
        {currentStep === 2 && (
          <ScheduleStep 
            formData={formData} 
            updateFormData={updateFormData}
            handleTimeSelection={handleTimeSelection}
            decrementDose={decrementDose}
            removeDoseTime={removeDoseTime}
          />
        )}
        
        {currentStep === 3 && (
          <CycleStep 
            formData={formData} 
            updateFormData={updateFormData} 
          />
        )}
        
        {currentStep === 4 && (
          <AdditionalInfoStep 
            formData={formData} 
            updateFormData={updateFormData} 
          />
        )}
      </div>
    </div>
  );
};

export default ModalContent;
